import {useEffect, useRef, useState} from 'react';
import { Col, Row, Typography, Table, Tag, Select, Space, Card, List } from 'antd';
import api from "../../API";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title as TitleChart,
  Tooltip as TooltipChart,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { ADMINS_EMAILS } from '../../config';
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TitleChart,
  TooltipChart,
  Legend
);

const { Title, Paragraph} = Typography

function Dashboard() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [campaignSource, setCampaignSource] = useState([]);
  const [packageOASource, setPackageOASource] = useState([]);
  const [dataLine, setDataLine] = useState({lables: [], datasets: []});
  const [OAIdOptions, setOAIdOptions] = useState([]);
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const originalMessages = useRef([]);
  const originalCampaigns = useRef([]);
  const originalPackageOAs = useRef([]);
  const columns1 = [
    {
      title: "Name",
      width: '16%',
      dataIndex: "campaignName",
    }, 
    {
      title: "Message Type",
      width: '16%',
      dataIndex: "messageType",
    },
    {
      title: "Date & Time",
      dataIndex: "createDate",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => {
        return <Tag color="success">{text.toUpperCase()}</Tag>
      }
    }
  ];
  const columns2 = [
    {
      title: "OA ID",
      dataIndex: "OAId",
      width: '15%',
    },
    {
      title: "OA Name",
      dataIndex: "accountName",
      width: '20%',
    },
    {
      title: "Total Message Buy",
      dataIndex: "total_message",
      width: '20%',
    },
    {
      title: "Total Message Sent",
      dataIndex: "totalMessageSent", 
      width: '20%',
    },
    {
      title: "Remain Message",
      dataIndex: "remainMessage",
      width: '20%',
    }
  ];
  const optionsOfChart = {
    layout:{
      padding: {
        bottom: 35
      }
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          boxHeight:0
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: 'white',
        bodyColor: 'white', 
        borderWidth: 1,
        borderColor: 'white', 
        callbacks: {
          title: (tooltipItems) => {
            return `Day: ${tooltipItems[0].label}`; // Tiêu đề của tooltip
          },
        }
      }
    },
    scales: {
      x: {
        title: { display: true, text: `Days in ${new Date().toLocaleString('en-US', {month: 'long'})} ${new Date().getFullYear()}` }
      },
      y: {
        title: { display: true, text: 'Volume' }
      }
    }
  }

  function getDataLine(TplId, labels, messages) {
    return labels.map(val => messages.filter(msg => {
      const msgYear = (new Date(msg.sentAt)).getFullYear();
      const msgMonth = (new Date(msg.sentAt)).getMonth();
      const msgDay = (new Date(msg.sentAt)).getDate();
      return msg[TplId] && msgYear === currentYear && msgMonth === currentMonth && parseInt(val.replace("(N)", "")) === msgDay 
    }).length)
  }

  function filterDashboardByOAID(campaigns, messages, packageOAs) {
    setCampaignSource(campaigns.map(cmpObj => {
      let messageType = cmpObj?.template_type?.at(0).toUpperCase() + cmpObj?.template_type?.slice(1);
      if(messageType === 'Gmfconsultant') messageType = 'Consultant';
      return ({
        key: cmpObj.campaignId,
        campaignName: cmpObj?.campaignName,
        messageType,
        createDate: new Date(cmpObj.createDate).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric'}),
        status: 'Completed'
      })
    }));
  
    const labels = Array.from({ length: daysInMonth }, (_, i) => (i+1) === new Date().getDate()? `${i + 1}(N)`:`${i + 1}`);
    setDataLine({
      labels,
      datasets:[
        {
          label: 'Transaction',
          data: getDataLine('transactionalTplId', labels, messages),
          fill: false,
          borderColor: '#ace0f4',
          tension: 0.1,
        },
        {
          label: 'Promotion',
          data: getDataLine('promotionTplId', labels, messages),
          fill: false,
          borderColor: '#018dc7',
          tension: 0.1,
        },
        {
          label: 'Consultant',
          data: getDataLine('consultingTplId', labels, messages),
          fill: false,
          borderColor: '#4fb432',
          tension: 0.1,
        },
      ]
    })
    if(!(user?.parentId)) setPackageOASource(packageOAs.map(pkgOA => {
      const totalMessageSent = messages.filter(msg => msg.OAId === pkgOA.OAId).length;
      return ({
        OAId: pkgOA.OAId,
        key: pkgOA.id,
        accountName: pkgOA.accountName,
        total_message: pkgOA.total_message,
        totalMessageSent,
        remainMessage: pkgOA.total_message - totalMessageSent,
    })}))
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const [oaaccounts, campaigns, messages] = await Promise.all([
          api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id", "accountName", "OAId"]),
          api.list_all_campaigns(user?.userId),
          api.list_all_success_messages(user?.userId, user?.parentId)
        ]);
        if (oaaccounts?.length) 
        setOAIdOptions(oaaccounts.map(oaaccount => ({
          value: oaaccount.OAId,
          label: oaaccount.accountName
        })));

        const packageOAs = !(user?.parentId)? await Promise.all(
          oaaccounts.map(oaaccount => 
            api.list_packagesOA_byOAId(oaaccount.OAId, ["id", "OAId", "total_message"])
          )
        ): [];
        const processedPackageOAs = packageOAs.flat().map(pkgOA => ({
          ...pkgOA,
          accountName: oaaccounts.find(oa => oa.OAId === pkgOA.OAId)?.accountName
        }));
        originalCampaigns.current = campaigns;
        originalMessages.current = messages;
        originalPackageOAs.current = processedPackageOAs;
        filterDashboardByOAID(campaigns, messages, processedPackageOAs);
      } catch (error) {
        console.error("Error fetching dashboard data:", error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []); 
  
  function handleOAId(selectedValue) {
    if(!selectedValue) {
      return  filterDashboardByOAID(originalCampaigns.current, originalMessages.current, originalPackageOAs.current); 
    }
    const newPackageOAs = originalPackageOAs.current.filter(pkgOA => pkgOA.OAId === selectedValue);
    const newCampaigns = originalCampaigns.current.filter(campaign => campaign.OAId === selectedValue);
    const newMessages = originalMessages.current.filter(msgObj => msgObj.OAId === selectedValue);
    filterDashboardByOAID(newCampaigns, newMessages, newPackageOAs);
  }

  return (
    <List split={false}>
      <List.Item>
        <Select
          popupMatchSelectWidth={false}
          options={OAIdOptions}
          showSearch
          allowClear
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          placeholder="Select OA Account"
          onChange={handleOAId}
        />
      </List.Item>
      <List.Item>
        <Card 
          style={{boxSizing: 'border-box', boxShadow: '0px 5px 5px #ccc',  width: '100%', height: '500px'}}
          title= {
            <Title level={4} style={{margin: 0}}>Recent Traffics</Title>
          }
          styles={{body: {height: '100%'}}}
        >
          <Line
            data={dataLine}
            options={optionsOfChart}/>
        </Card>
      </List.Item>
      <List.Item>
        <Card 
          style={{boxShadow: '0px 5px 5px #ccc', width: '100%', height: '500px'}}
          title={<>
            <Title level={4} style={{margin: 0}}>Campaigns</Title>
          </>}
        >
          <Paragraph style={{marginTop: 0}}>This is a list of latest broadcasts.</Paragraph>
          <Table  
            bordered
            scroll={{x: 1000}}
            style={{ width: '100%'}}
            columns= {columns1} 
            dataSource={campaignSource}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, // Disable page size changer
              pageSize: 4, 
              showTotal: () => `Total: ${campaignSource.length} items`
            }}
          />
        </Card>
      </List.Item>
      { !(user?.parentId) &&
      <List.Item>
        <Card
          style={{boxShadow: '0px 5px 5px #ccc', width: '100%', height: '500px'}}
          title={<>
            <Title level={4} style={{margin: 0}}>License Summary</Title>
          </>}
        >
          <Table  
            bordered
            scroll={{x: 1000}}
            style={{ width: '100%'}}
            columns= {columns2} 
            dataSource={packageOASource}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, // Disable page size changer
              pageSize: 4, 
              showTotal: () => `Total: ${packageOASource.length} items`
            }}
          />
        </Card>
      </List.Item>}
    </List>
  )
}

export default Dashboard;